import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-logo-container", [_ctx.collapse ? 'collapse': 'notitle']])
  }, [
    _createVNode(_Transition, { name: "sidebarLogoFade" }, {
      default: _withCtx(() => [
        false
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: "collapse",
              class: "sidebar-logo-link",
              to: "/"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  src: "favicon.ico",
                  class: "sidebar-logo"
                }, null, -1)
              ])),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: "expand",
              class: "sidebar-logo-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "sidebar-logo",
                  src: require('@/assets/imgs/logo.png')
                }, null, 8, _hoisted_1),
                _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "sidebar-title" }, "蛋糕叔叔", -1))
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ], 2))
}